import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LgvConstants } from '../../core/core.module';
import { SocialMediaType } from '../../core/utility/lgv-constants';

@Component({
    selector: 'lgv-social-media-icon',
    templateUrl: './social-media-icon.component.html',
    styleUrls: ['./social-media-icon.component.scss']
})
export class SocialMediaIconComponent implements OnInit {

    @Input() socialMediaType: SocialMediaType;
    iconWidth: number = 16;
    iconHeight: number = 16;
    @Input() iconClass: string = '';

    get isFacebook(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.Facebook; }
    get isLinkedin(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.LinkedIn; }
    get isThreads(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.Threads; }
    get isXTwitter(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.XTwitter; }
    get isInstagram(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.Instagram; }
    get isYoutube(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.Youtube; }
    get isYelp(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.Yelp; }
    get isGoogle(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.Google; }
    get isZillow(): boolean { return this.socialMediaType.toUpperCase() === SocialMediaType.Zillow; }

    constructor() {
    }

    ngOnInit(): void {
        if (!!this.iconClass) {
            switch (this.iconClass) {
                case 'fa-lg': {
                this.iconWidth = 21;
                this.iconHeight = 21;
                break;
            }
                case 'fa-2x': {
                    this.iconWidth = 32;
                    this.iconHeight = 32;
                    break;
                }
            }
        }
    }

}
